import PropTypes from 'prop-types';

import { ShipFromPropType } from '../../prop-types/ship-from';

export const SHIP_TO_ADDRESS_TYPE = 0;
export const CREATE_LABEL_CONTENT_RETURN_FROM_ADDRESS_TYPE = 1;
export const NEW_SHIP_FROM_LOCATION_ADDRESS_TYPE = 2;

export const AddressType = PropTypes.oneOf([
  SHIP_TO_ADDRESS_TYPE,
  CREATE_LABEL_CONTENT_RETURN_FROM_ADDRESS_TYPE,
  NEW_SHIP_FROM_LOCATION_ADDRESS_TYPE,
]);

export const fieldComponentPropType = {
  address: ShipFromPropType,
  onChange: PropTypes.func.isRequired,
};
